import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { Form } from '@unform/web';
import { includes, isArray } from 'lodash';
import PropTypes from 'prop-types';
import qs from 'querystring';
import * as Yup from 'yup';

import { Spinner, Table } from '~/components';
import {
  Input,
  Combobox,
  DateTime,
  Autocomplete,
  Select,
  Hidden,
} from '~/components/Form';
import {
  CENTRO_CUSTO_ABASTECIMENTO,
  MOTORISTA_ABASTECIMENTO,
  TRR_CHILE,
  CUSTOMIZACAO_RAIZEN,
} from '~/constants/modules';
import { t, can } from '~/helpers';
import { getToastErrors } from '~/helpers/errorsRequest';
import api from '~/services/api';

import { Container } from './styles';

export default function CreateOrUpdate({
  data,
  reference,
  close,
  cancelarAcao,
}) {
  const { client } = useSelector((state) => state.user.profile);
  const [posto, setPosto] = useState(0);
  const [motorista, setMotorista] = useState(null);
  const [totalizador, setTotalizador] = useState(0);
  const [custo, setCusto] = useState(null);
  const [compartments, setCompartments] = useState([]);

  const {
    internounidatausuario,
    formaidfrentistaabast,
    exibeoslubrificacao,
  } = useSelector((state) => state.user.configs);

  const [
    itemsobslibintegraatendimentolubrificacao,
    setItemsobslibintegraatendimentolubrificacao,
  ] = useState([]);

  const [loading, setLoading] = useState(true);
  const [initials, setInitials] = useState(null);
  const [idatendimento, setIdatendimento] = React.useState(null);
  const [
    idatendimentolubrificacao,
    setIdatendimentolubrificacao,
  ] = React.useState(null);
  const [idposto, setIdposto] = React.useState(null);
  const [idmovimentacao, setIdmovimentacao] = React.useState(null);

  // const optionsAprovacao = useMemo(
  //   () => [
  //     { value: '1', label: t('s.geral.opcoes.pendente') },
  //     { value: '2', label: t('s.geral.opcoes.aprovado') },
  //     { value: '3', label: t('s.geral.opcoes.naoaprovado') },
  //     { value: '4', label: t('s.geral.opcoes.reenvioparaaprovacao') },
  //   ],
  //   []
  // );

  const [
    statuslibintegraatendimentoalubrificacao,
    setStatuslibintegraatendimentoalubrificacao,
  ] = React.useState(0);

  const optionsAprovacao = useMemo(() => {
    if (statuslibintegraatendimentoalubrificacao === 3) {
      return [{ value: '4', label: t('s.geral.opcoes.reenvioparaaprovacao') }];
    }

    return [
      { value: '1', label: t('s.geral.opcoes.pendente') },
      { value: '2', label: t('s.geral.opcoes.aprovado') },
      { value: '3', label: t('s.geral.opcoes.naoaprovado') },
      // { value: '4', label: t('s.geral.opcoes.reenvioparaaprovacao') },
    ];
  }, [statuslibintegraatendimentoalubrificacao, t]);

  const cellsHistorico = useMemo(
    () => [
      {
        id: 'obsatendimentolubrificacaohistoricomsg',
        label: t(
          's.operacao.checkliberadoparaintegracao.obslibintegraatendimentoabastecimento'
        ),
      },
      {
        id: 'dataeventoatendimentolubrificacaohistoricomsg',
        label: t(
          's.operacao.checkliberadoparaintegracao.obslibintegraatendimentoabastecimento'
        ),
      },
    ],
    []
  );

  useEffect(() => {
    if (initials) {
      setPosto(initials.idposto);
      setTotalizador(Number(initials.tipototalizadorveiculo));

      console.log(JSON.stringify(initials));

      handleResponseDataItemsLubrificacaohistoricomsg(
        initials.idposto,
        initials.idatendimento
      );

      setLoading(false);
    }
  }, [initials]);

  useEffect(() => {
    async function handleCarregaAtendimento(
      idmovimentacao,
      idatendimento,
      idposto
    ) {
      const { data } = idmovimentacao
        ? await api.get(
            `pitstop/lubrificacao/movimentacao/${idmovimentacao}/${idposto}`
          )
        : await api.get(`pitstop/lubrificacao/${idatendimento}/${idposto}`);
      setIdmovimentacao(idmovimentacao);
      setIdatendimento(idatendimento);
      setIdposto(data.idposto);
      setInitials(data);
    }

    async function getCompartiments(vehicle, product) {
      const response = await api.get('veiculoscompartimentos', {
        params: {
          wherefield: ['idveiculo', 'idproduto'],
          typewherefield: ['EQUALS', 'EQUALS'],
          valuewherefield: [vehicle, product],
          pesquisalista: true,
        },
        paramsSerializer: (param) => qs.stringify(param),
      });
      if (response.data.items) {
        setCompartments(
          response.data.items.map((i) => ({
            label: `${i.idcompartimento} - ${i.descricaocompartimento}`,
            value: i.idcompartimento,
          }))
        );
      }
    }
    if (data != null) {
      setStatuslibintegraatendimentoalubrificacao(
        data.statuslibintegraatendimentolubrificacao
      );

      console.log(JSON.stringify(data));

      handleCarregaAtendimento(
        data.idmovimentacao,
        data.idatendimento,
        data.idposto
      );
      getCompartiments(data.idveiculo, data.idproduto);
    }
  }, [data]);

  useEffect(() => {
    async function handleCarregaLubrificante(idatendimento) {
      const { data } = await api.get(`/pitstop/lubrificacao/${idatendimento}`);
      setIdatendimentolubrificacao(data.idatendimentolubrificacao);
      // setLoading(true);
    }
    if (idatendimento) {
      handleCarregaLubrificante(idatendimento);
    }
  }, [idatendimento]);

  async function handleCloseModal() {
    await this.setState({ open: false });
  }

  async function hancleCancelarAcao() {
    await this.setState((prevState) => ({
      ...prevState,
    }));
  }

  const valorSelecionado = (campo) => {
    const valor = document.getElementById(campo).innerText;
    if (valor === '') {
      return null;
    }
    const option = optionsAprovacao.find((item) => item.label === valor);
    return option ? option.value : null;
  };

  const handleResponseDataItemsLubrificacaohistoricomsg = useCallback(
    async (idposto, idatendimento) => {
      try {
        if (idposto) {
          setLoading(true);

          await api
            .get(
              `/pitstop/atendimentolubrificacaohistoricomsg/${idposto}/${idatendimento}`
            )
            .then((response) =>
              setItemsobslibintegraatendimentolubrificacao(response.data)
            );
        }
      } catch (err) {
        getToastErrors(err);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        obslibintegraatendimentolubrificacao: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
        statuslibintegraatendimentolubrificacao: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        idatendimentolubrificacao,
        idatendimento,
        idcliente: client,
        idposto,
        idmovimentacao,
        obslibintegraatendimentolubrificacao:
          param.obslibintegraatendimentolubrificacao,
        statuslibintegraatendimentolubrificacao: valorSelecionado(
          'statuslibintegraatendimentolubrificacao'
        ),
      };
      await api.put(
        'pitstop/alteraatendimentolubrificacaoconfirmaadm',
        objSend
      );
      await close();
      toast.success(t('s.geral.sucessoalteracao'));
    } catch (err) {
      if (err && isArray(err)) {
        toast.error(err[0]);
      }
      await cancelarAcao();
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });
        reference.current.setErrors(validationErrors);
      }
      // if (err && isArray(err)) {
      //   toast.error(err[0]);
      // }
      // await cancelarAcao();
    }
  }

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <>
          <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
            <Container>
              <Autocomplete
                name="idposto"
                disabled
                disableClearable
                label="codigonomeposto"
                url="postoscomboios"
                unique="idposto"
                title={t('s.menu.configuracao.posto')}
              />

              <Combobox
                name="idbico"
                disabled
                label="bicoprodutobico"
                url="bicos"
                unique="idbico"
                title={t('s.menu.configuracao.bico')}
                hiddens={[{ name: 'idterminal' }, { name: 'idproduto' }]}
                params={{
                  wherefield: ['idposto', 'tipoproduto'],
                  valuewherefield: [posto.idposto, 'L'],
                  typewherefield: ['EQUALS', 'EQUALS'],
                  fieldlist: 'idbico, idterminal, idproduto, bicoprodutobico',
                }}
              />

              <DateTime
                time
                name="datahorainicialmovimentacao"
                disabled
                label={t(
                  's.operacao.abastecimento.datahorainicialmovimentacao'
                )}
              />

              <DateTime
                time
                name="datahorafinalmovimentacao"
                disabled
                label={t('s.operacao.abastecimento.datahorafinalmovimentacao')}
                style={{ marginTop: 16 }}
              />

              <Input
                name="idveiculo"
                disabled
                label={
                  !can(TRR_CHILE)
                    ? t('s.operacao.abastecimento.idveiculo')
                    : t('s.cadastro.codigoempresacliente')
                }
                style={{ marginTop: 16 }}
              />

              <Autocomplete
                name="idempresaveiculo"
                label={
                  can(CUSTOMIZACAO_RAIZEN)
                    ? 'idempresaveiculo'
                    : 'nomeempresaveiculo'
                }
                url="empresasveiculos"
                unique="idempresaveiculo"
                title={t('s.cadastro.veiculo.idempresaveiculo')}
                disabled
              />

              {can(CENTRO_CUSTO_ABASTECIMENTO) && (
                <Input
                  name="idcentrocusto"
                  disabled
                  label={t('s.operacao.abastecimento.idcentrocusto')}
                  value={custo}
                />
              )}

              <Input
                name="totalizadormovimentacaoabastecimento"
                type="number"
                disabled
                label={t(
                  `s.operacao.abastecimento.${
                    totalizador === 1 ? 'horimetro' : 'hodometro'
                  }`
                )}
                style={{
                  display: includes([1, 2], totalizador) ? 'block' : 'none',
                }}
              />

              <Input
                name="encerranteinicialmovimentacao"
                disabled
                label={t(
                  's.operacao.abastecimento.encerranteinicialmovimentacao'
                )}
                type="number"
              />

              <Input
                name="encerrantefinalmovimentacao"
                disabled
                label={t(
                  's.operacao.abastecimento.encerrantefinalmovimentacao'
                )}
                type="number"
              />

              <Input
                name="volumemovimentacao"
                disabled
                label={t('s.operacao.abastecimento.volumemovimentacao')}
                type="number"
              />

              {formaidfrentistaabast !== 0 && (
                <Input
                  name="codigousuario"
                  disabled
                  label={t('s.operacao.abastecimento.codigousuario')}
                />
              )}

              {can(MOTORISTA_ABASTECIMENTO) && (
                <Input
                  name="idmotorista"
                  disabled
                  label={t('s.operacao.abastecimento.idmotorista')}
                  value={motorista}
                />
              )}

              <Select
                name="idcompartimento"
                label={t('s.operacao.lubrificacao.idcompartimento')}
                options={compartments}
                disabled
              />

              <Select
                name="trocalubmovimentacaolubrificacao"
                label={t(
                  's.operacao.lubrificacao.trocalubmovimentacaolubrificacao'
                )}
                options={[
                  { label: t('s.geral.opcoes.nao'), value: 0 },
                  { label: t('s.geral.opcoes.sim'), value: 1 },
                ]}
                disabled
              />

              {exibeoslubrificacao === 1 && (
                <Input
                  name="numeroosmovimentacaolubrificacao"
                  label={t(
                    's.operacao.lubrificacao.numeroosmovimentacaolubrificacao'
                  )}
                />
              )}

              <Select
                name="statuslibintegraatendimentolubrificacao"
                id="statuslibintegraatendimentolubrificacao"
                label={t(
                  's.operacao.checkliberadoparaintegracao.statuslibintegraatendimentolubrificacao'
                )}
                options={optionsAprovacao}
                // defaultValue={antifurtoabastecimento}
                style={{ marginTop: 8 }}
                // getValue={(value) => setAntifurtoabastecimento(value)}
              />

              <Input
                id="obslibintegraatendimentolubrificacao"
                name="obslibintegraatendimentolubrificacao"
                label={t(
                  's.operacao.checkliberadoparaintegracao.obslibintegraatendimentolubrificacao'
                )}
                multiline
                rows={3}
                inputProps={{ maxLength: 255 }}
                style={{ marginTop: 12 }}
              />

              {/* <Input
              name="observacaolubrificacao"
              label={t('s.cadastro.pitstop.observacaoatendimento')}
              multiline
              rows={3}
              inputProps={{ maxLength: 255 }}
              style={{ marginTop: 4 }}
            /> */}

              <Hidden
                name="idatendimentolubrificacao"
                devaultValue={idatendimentolubrificacao}
              />
            </Container>
          </Form>
          <Table
            isResponsive
            size="small"
            height="18rem"
            paginate={99}
            showPagination={false}
            cells={cellsHistorico}
            data={itemsobslibintegraatendimentolubrificacao ?? []}
            loding={loading}
          />
        </>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
